module.exports = __webpack_public_path__ + "static/media/javascript.8b8524a4.png";